import { z } from 'zod';

export const VoltageClassSchema = z.object({
    label: z.string(),
    min: z.number(),
    max: z.number(),
    color: z.string(),
});
